import React from 'react';
import { ProgressRing } from './ProgressRing';
import { BookOpenIcon, SlidersIcon, TargetIcon, ZapIcon } from './icons/InterfaceIcons';

const PillButton = ({ icon, label, colorClass, textColorClass, onClick = () => {} }) => (
    <button onClick={onClick} className={`flex items-center justify-center space-x-2 py-2 px-3 rounded-full text-xs font-semibold transition-all duration-300 bg-opacity-10 hover:bg-opacity-20 ${colorClass} ${textColorClass}`}>
        {icon}
        <span>{label}</span>
    </button>
);

// FIX: Add explicit types for props to allow 'key' prop in map.
export const ExamCard: React.FC<{ exam: any, onViewMockTests: (exam: any, mode?: string) => void, onSelectPracticeMode: (exam: any, mode: string) => void }> = ({ exam, onViewMockTests, onSelectPracticeMode }) => {
  const getBadgeColor = (badge) => {
    if (badge.toLowerCase().includes('trending')) return 'bg-brand-primary/10 text-brand-primary';
    if (badge.toLowerCase().includes('new')) return 'bg-brand-secondary/10 text-brand-secondary';
    if (badge.toLowerCase().includes('weak')) return 'bg-brand-accent-amber/10 text-brand-accent-amber';
    return 'bg-gray-100 text-brand-text-secondary';
  };

  return (
    <div className={`group bg-brand-surface border border-brand-border rounded-2xl p-6 flex flex-col space-y-4 transition-all duration-300 ease-in-out relative ${exam.status === 'coming-soon' ? 'opacity-60 grayscale cursor-not-allowed' : 'hover:border-brand-primary hover:shadow-card-hover hover:-translate-y-1'}`}>
      {exam.status === 'coming-soon' && (
        <div className="absolute top-4 right-4 bg-brand-accent-amber text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-lg z-10">
          Coming Soon
        </div>
      )}
      {/* Card Header */}
      <div className="flex items-start justify-between">
        <div className="flex items-center space-x-4">
          <div className="relative w-14 h-14 flex items-center justify-center bg-brand-bg rounded-full border-2 border-brand-border">
            <div className="w-8 h-8 text-brand-text-primary">
                {exam.emblem}
            </div>
          </div>
          <div>
            <h2 className="font-bold text-xl text-brand-text-primary">{exam.name}</h2>
            <p className="text-sm text-brand-text-secondary">{exam.subtitle}</p>
          </div>
        </div>
        <div className="relative">
            <ProgressRing progress={exam.progress} />
        </div>
      </div>

      {/* Badges */}
      {exam.badges.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {exam.badges.map((badge, index) => (
            <span key={index} className={`text-xs font-medium px-2.5 py-1 rounded-full ${getBadgeColor(badge)}`}>
              {badge}
            </span>
          ))}
        </div>
      )}

      {/* Action Pills */}
      <div className="grid grid-cols-2 gap-2 pt-2">
        <PillButton onClick={() => onSelectPracticeMode(exam, 'paper-wise')} icon={<BookOpenIcon className="w-4 h-4" />} label="Paper Wise" colorClass="bg-brand-secondary" textColorClass="text-brand-secondary" />
        <PillButton onClick={() => onSelectPracticeMode(exam, 'chapter-wise')} icon={<SlidersIcon className="w-4 h-4" />} label="Chapter Wise" colorClass="bg-brand-accent-amber" textColorClass="text-brand-accent-amber" />
        <PillButton onClick={() => onViewMockTests(exam, 'mock-list')} icon={<ZapIcon className="w-4 h-4" />} label="Mock Tests" colorClass="bg-brand-accent-violet" textColorClass="text-brand-accent-violet" />
        <PillButton onClick={() => onSelectPracticeMode(exam, 'adaptive')} icon={<TargetIcon className="w-4 h-4" />} label="Adaptive" colorClass="bg-brand-primary" textColorClass="text-brand-primary" />
      </div>

      {/* Main CTA */}
      <div className="pt-2 flex-grow flex flex-col justify-end">
        <button 
          onClick={() => onViewMockTests(exam)}
          disabled={exam.status === 'coming-soon'}
          className="w-full bg-brand-primary hover:bg-brand-primary-hover text-white font-bold py-3 px-4 rounded-lg transition-opacity disabled:bg-gray-400 disabled:cursor-not-allowed cursor-pointer">
          {'Practice Questions'}
        </button>
      </div>

      {/* Card Footer */}
      <div className="flex justify-between items-center text-xs text-brand-text-secondary pt-2">
        <span>Last attempt: {exam.lastAttempt}</span>
        <span>Avg. Accuracy: <span className="font-semibold text-brand-text-primary">{exam.avgAccuracy > 0 ? `${exam.avgAccuracy}%` : 'N/A'}</span></span>
      </div>
    </div>
  );
};